import React from "react";

import { formatNumber } from "utils";

import { Col, PayoutInVerificationCard, Row, Typography } from "components";

export const PayoutHistory = ({ payouts, currency }) => {
  const years = [...new Set(payouts.map(({ year }) => year))].sort((a, b) => b - a);
  const sortedData = {};

  for (const payoutYear of years) {
    sortedData[payoutYear] = payouts.filter(({ year }) => year === payoutYear);
  }

  return (
    <>
      {years.map((year, i) => (
        <Row key={i}>
          <Col>
            <Typography variant="h3" className="margin-top-200">
              {year}
            </Typography>
          </Col>
          {sortedData[year].map(({ approvedCredits, initialCredits, approved, payoutAtVerificationStart }, i) => {
            // Show initial credits vs approved credits when there's a difference
            const hasChanges = initialCredits && initialCredits !== approvedCredits;

            return (
              <Col key={i} md={12} sm={12}>
                <PayoutInVerificationCard
                  className={`payout-history-card ${approved ? "approved" : "rejected"}`}
                  // PayoutInVerificationCard component takes a range, because it needs to support range or no range
                  // In PayoutHistory we for sure will only have 1 accurate value
                  payout="Payout finalized after certification"
                  preVerificationPayout={payoutAtVerificationStart}
                  status={approved ? "approved" : "rejected"}
                  year={+year}
                  currency={currency}
                >
                  <div className="payout-card-credits">
                    <Typography variant="paragraph-m">total carbon credits</Typography>
                    <div>
                      {hasChanges ? (
                        <Typography variant="paragraph-m" className="rejected">
                          {formatNumber({ number: initialCredits, decimalPlaces: 2 })}
                        </Typography>
                      ) : null}
                      {approved && (
                        <Typography variant="paragraph-m" bold>
                          {formatNumber({ number: approvedCredits, decimalPlaces: 2 })}
                        </Typography>
                      )}
                    </div>
                  </div>
                </PayoutInVerificationCard>
              </Col>
            );
          })}
        </Row>
      ))}
    </>
  );
};
